module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CropperImage'
      }),
      expression: "{ name: 'CropperImage' }"
    }]
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "user-face",
    attrs: {
      "src": _vm.row2.face,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("设置头像")])]), _vm._v(" "), _c('div', {
    staticClass: "br"
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": _vm.row.name,
      "label": "昵称",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.toSetUserName
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": _vm.row2.phone,
      "label": "登录手机号",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.toSetPhone
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserPassword'
      }),
      expression: "{ name: 'UserPassword' }"
    }],
    attrs: {
      "label": "登录密码",
      "value": "*******",
      "label-width": "150",
      "input-align": "right",
      "is-link": "",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'Qualifications'
      }),
      expression: "{ name: 'Qualifications' }"
    }],
    attrs: {
      "value": "立即前往",
      "label": "审核资质申诉&增补",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  })], 1)]), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "box"
  }, [_c('van-field', {
    attrs: {
      "value": _vm.cacheSize,
      "label": "清除缓存",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.clearCache
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'Feedback'
      }),
      expression: "{ name: 'Feedback' }"
    }],
    attrs: {
      "value": "",
      "label": "用户反馈",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": "",
      "label": "账号注销",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.kill
    }
  })], 1)]), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "box"
  }, [_c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ContentDetail',
        query: {
          id: 346
        }
      }),
      expression: "{ name: 'ContentDetail', query: { id: 346 } }"
    }],
    attrs: {
      "value": "",
      "label": "关于我们",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ContentDetail',
        query: {
          id: 452
        }
      }),
      expression: "{ name: 'ContentDetail', query: { id: 452 } }"
    }],
    attrs: {
      "value": "",
      "label": "资质证照",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ContentDetail',
        query: {
          id: 338
        }
      }),
      expression: "{ name: 'ContentDetail', query: { id: 338 } }"
    }],
    attrs: {
      "value": "",
      "label": "协议规则",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": "",
      "label": "退出登录",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": _vm.logout
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dccbf2c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/setting/Setting.vue
// module id = 2593
// module chunks = 0